import React from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';

import EventSelectorButton from '../../components/EventSelector/Button';
import EventSelector from '../../components/EventSelector/Modal';
import Controls from './Controls';
import DataExplore from './explore';
import DetailDrawer from './DetailDrawer';
import Preview from './Preview';
import SRS from './srs';
import useCrowdCount from './useCrowdCount';
import style from './style.module.scss';

/** Inside `<SRS>` so useRound can annotate face clicks. */
const Body = ({ cc }) => {
  const onDetail = SRS.useRound(cc.setDetail);
  const exploring = !cc.detectionsLoading && (
    (cc.isGroup && cc.scans.length > 0) || (!cc.isGroup && cc.singleScan)
  );

  return (
    <>
      <Controls
        scanOptions={cc.scanOptions}
        option={cc.option}
        onScanChange={cc.setOption}
        onScanStep={cc.goScan}
        hasScans={cc.hasScans}
        canNavigate={cc.canNavigate}
        detectableOptions={cc.detectableOptions}
        selectedOptions={cc.selectedOptions}
        onDetectablesChange={cc.setSelectedLabels}
        showBoxes={cc.showBoxes}
        onToggleBoxes={() => cc.setShowBoxes((v) => !v)}
        onArrangeSaved={cc.reloadLayouts}
      />

      {(cc.sessionsLoading || cc.scanLoading) && !cc.showRegion && !cc.showStadium && (
        <div className={style.empty}><Spinner animation="border" /></div>
      )}

      <Preview
        showStadium={cc.showStadium}
        showRegion={cc.showRegion}
        shimmer={cc.shimmer}
        optionValue={cc.optionValue}
        stadiumEntries={cc.stadiumEntries}
        singleScan={cc.singleScan}
        tiles={cc.tiles}
        rows={cc.rows}
        cols={cc.cols}
        tileBoxes={cc.tileBoxes}
        selectedLabels={cc.selectedLabelSet}
        showBoxes={cc.showBoxes}
        onOpenDetail={onDetail}
        scanLoading={cc.scanLoading}
      />

      {exploring && (
        <DataExplore
          tiles={cc.tiles}
          tileBoxes={cc.tileBoxes}
          rekognitionLabels={cc.rekognitionLabels}
          rows={cc.isGroup ? 1 : (cc.singleScan?.rows || cc.rows)}
          cols={cc.isGroup ? 1 : (cc.singleScan?.cols || cc.cols)}
          showTileCoverage={!cc.isGroup}
          onOpenDetail={onDetail}
        />
      )}

      {!cc.sessionsLoading && !cc.hasScans && (
        <div className={style.empty}>No crowd count scans for this event.</div>
      )}
      {!cc.scanLoading && cc.scanError && (
        <div className={style.empty}>
          Couldn&apos;t load this scan. Try another or refresh.
        </div>
      )}
      {!cc.scanLoading && !cc.scanError && !cc.isGroup
        && cc.singleScan && !cc.tiles.length && (
        <div className={style.empty}>This scan has no tile images.</div>
      )}
    </>
  );
};

const CrowdCount = ({ event, selectedEventsPage }) => {
  const cc = useCrowdCount(event, selectedEventsPage);

  return (
    <div className="d-flex flex-column flex-grow-1">
      <div className="pageHeader">
        <h4>Crowd Count</h4>
        <EventSelectorButton showFutureEvents />
      </div>

      <SRS scans={cc.scans}>
        <div className={style.content}>
          {!event && (
            <div className={style.empty}>Select an event to review crowd count scans.</div>
          )}
          {event ? <Body cc={cc} /> : null}
        </div>
      </SRS>

      <DetailDrawer detail={cc.detail} onClose={() => cc.setDetail(null)} />
      <EventSelector singleSelection showTemplate />
    </div>
  );
};

export default connect(
  ({ events: { selectedEvents, selectedEventsPage } }) => ({
    event: selectedEvents[0],
    selectedEventsPage,
  }),
)(CrowdCount);
